<template>
    <!-- <IndependentAcceleratorsView /> -->
    <h2>
        <img src="../assets/images/quote-img.png" class="favicon me-2">Check back soon....
    </h2>
</template>

<script>
import { pageViews } from "../utils/util";
import IndependentAcceleratorsView from "../views/IndependentAcceleratorsView.vue";

export default {
    name: pageViews.VIEW_404,
    components: {
        /* IndependentAcceleratorsView, */
    }
     
}

</script>